var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// Imports
import Vue from "vue";
import Component from "vue-class-component";
import moment from "moment";
import { Rounds } from "../../modules/rounds";
// Define vue parameters
var StatsComponent = /** @class */ (function (_super) {
    __extends(StatsComponent, _super);
    /**
     * Setup the child and parent class
     */
    function StatsComponent() {
        var _this = _super.call(this) || this;
        _this.currentAverages = 0;
        _this.averages = {
            raw: {
                averagePar3GrossScore: [],
                averagePar4GrossScore: [],
                averagePar5GrossScore: [],
                averagePuttTotal: []
            },
            averaged: {}
        };
        // Create a rounds instance
        _this.rounds = new Rounds();
        return _this;
    }
    /**
     * Component setup on mount
     */
    StatsComponent.prototype.mounted = function () {
        var _this = this;
        // Get last 5 averages
        this.getAverages(1, 5)
            .then(function () {
            _this.formatAverages("lastFive");
        })
            .then(function () {
            // Get last 10 averages
            _this.getAverages(1, 10).then(function () {
                _this.formatAverages("lastTen");
            });
        })
            .then(function () {
            // Get year to date averages
            _this.getAverages(1, 10, moment().startOf("year"), moment()).then(function () {
                _this.formatAverages("thisYear");
            });
        })
            .then(function () {
            // Get last year averages
            _this.getAverages(1, 10, moment()
                .subtract(1, "year")
                .startOf("year"), moment()
                .subtract(1, "year")
                .endOf("year")).then(function () {
                _this.formatAverages("lastYear");
            });
        })
            .then(function () {
            // Get all time averages
            _this.getAverages().then(function () {
                _this.formatAverages("allTime");
            });
        })
            .then(function () {
            console.log(_this.$data);
        });
    };
    /**
     * Formats averages and then clears them
     *
     * @param fieldString The averages within the $data array to append to
     */
    StatsComponent.prototype.formatAverages = function (fieldString) {
        var _this = this;
        // Loop through averages and append to $data
        Object.keys(this.averages.raw).forEach(function (key) {
            _this.$data[fieldString][key] = _this.averages.averaged[key];
        });
        // Reset averages in preparation for next set
        this.resetAverages();
    };
    /**
     * Reset averages in preparation for next set
     */
    StatsComponent.prototype.resetAverages = function () {
        var _this = this;
        this.averages.averaged = {};
        Object.keys(this.averages.raw).forEach(function (key) {
            _this.averages.raw[key] = [];
        });
    };
    /**
     * Recursively returns raw round stats
     *
     * @param from          The first result to get
     * @param to            The last result to get
     * @param createdAfter  The first date to get
     * @param createdBefore The last date to get
     */
    StatsComponent.prototype.getAverages = function (from, to, createdAfter, createdBefore) {
        var _this = this;
        if (from === void 0) { from = 1; }
        if (to === void 0) { to = 20; }
        // Run request
        return this.rounds
            .stats(from, to, createdAfter, createdBefore)
            .then(function (stats) {
            // Set current averages via length of response
            _this.currentAverages += stats.roundExtendedStats.length;
            // Append results to averages object via keys
            Object.keys(_this.averages.raw).forEach(function (key) {
                stats.roundExtendedStats.forEach(function (stat) {
                    _this.averages.raw[key].push(stat[key]);
                });
            });
            // Return result count for usage in next iteration
            return stats.resultsCount;
        })
            .then(function (results) {
            // If current iteration is less than results, continue iterating
            if (_this.currentAverages < results) {
                // Add 20 to new API call
                _this.getAverages(from + 20, to + 20, createdAfter, createdBefore);
            }
            else {
                // Average the results
                Object.keys(_this.averages.raw).forEach(function (key) {
                    // Default the sum before adding anything
                    var currentSum = 0;
                    var length = 0;
                    // Add to sum
                    _this.averages.raw[key].forEach(function (value) {
                        currentSum += value;
                        length += 1;
                    });
                    // Average it
                    _this.averages.averaged[key] = currentSum / length;
                });
            }
        });
    };
    StatsComponent = __decorate([
        Component({
            data: function () {
                return {
                    stats: null,
                    loading: true,
                    lastFive: {},
                    lastTen: {},
                    thisYear: {},
                    lastYear: {},
                    allTime: {}
                };
            }
        })
        // Define the component code
    ], StatsComponent);
    return StatsComponent;
}(Vue));
export default StatsComponent;
